<template>
  <svg
    :width="$attrs.width || 20"
    :height="$attrs.height || 20"
    :viewBox="$attrs.viewBox || '0 0 20 20'"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-html="path"
  ></svg>
</template>

<script setup>
import icons from '@/use/icons'

const props = defineProps({
  name: { type: String, default: 'search' },
})

const path = icons[props.name]
</script>
